import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import {DepartContext} from "./context/DepartContext";
import {DepartFilterContext} from "./context/DepartFilterContext";
import {DEPART_STATUS} from "../util/EntityStatusManager";
import Box from "@amzn/meridian/box";
import StageStatusViewV2 from "../stageStatus/StageStatusViewV2";
import ActionableMetricView from "../stageStatus/ActionableMetricView";
import ScrollableElementWrapper from "../common/ScrollableElementWrapper";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import {isNotINRegionOrSSD} from "../util/Util";
import {CapabilityContext} from "../global/context/CapabilityContext";

const DepartOverallStatus = () => {

    const {viewModel} = useContext(DepartContext)
    const {viewModelF, dispatchF} = useContext(DepartFilterContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {spacingInset_shorthand4} = useDeviceLayout()
    let routeList = Array.from(viewModel.routeList);
    const filterOption = (route, filter, key) => {
        if (viewModelF[filter].length === 0) {
            return true;
        }
        let result = false;
        viewModelF[filter].forEach(filterValue => {
            if (!route[key]
                || (filter === "status" && route[key] === filterValue)
                || (filter !== "status" && route[key].includes(filterValue))) {
                result = true;
            }
        })
        return result;
    }
        routeList = routeList
            .filter(route => filterOption(route, "cluster", "routeCode"))
            .filter(route => filterOption(route, "driverType", "routeType"))
            .filter(route => filterOption(route, "departure", "routeSLA"))
            .filter(route => filterOption(route, "status", "status"))
            .filter(route => filterOption(route, "departByTime", "departByTime"))




    const getDepartMetrics = (routes) => {
        const metrics = {
            totalRoutes: routes.length,
            notReadyRoutes: 0,
            readyRoutes: 0,
            partialDepartedRoutes: 0,
            departedRoutes: 0
        }
        routes.forEach(route => {
            switch (route.status) {
                case DEPART_STATUS.DEPARTED:
                    metrics.departedRoutes++;
                    break;
                case DEPART_STATUS.PARTIALLY_DEPARTED:
                    metrics.partialDepartedRoutes++;
                    break;
                case DEPART_STATUS.READY:
                    metrics.readyRoutes++;
                    break;
                case DEPART_STATUS.NOT_READY:
                    metrics.notReadyRoutes++;
                    break;
                default:
                    break;
            }
        });
        return metrics
    }

    let departMetrics = getDepartMetrics(routeList);
        return (
            <Row wrap="down" spacingInset={spacingInset_shorthand4} spacing="medium" width="100%"
                 alignmentVertical="stretch">

                <Box type="outline" spacingInset="medium">
                    <StageStatusViewV2 stageStatus={{
                        title: "depart.totalRoutes",
                        message: "Total routes",
                        value: departMetrics.totalRoutes
                    }}/>
                </Box>

                <Box type="outline" spacingInset="medium">
                    <ScrollableElementWrapper>
                        <Row width="100%" spacing="large" alignmentVertical="bottom">
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [DEPART_STATUS.NOT_READY]
                                })}
                                stageStatus={{
                                    title: "depart.notReady",
                                    message: "Not ready",
                                    value: departMetrics.notReadyRoutes
                                }}/>
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [DEPART_STATUS.READY]
                                })}
                                stageStatus={{
                                    title: "depart.ready",
                                    message: "Ready",
                                    value: departMetrics.readyRoutes
                                }}/>
                            {isNotINRegionOrSSD(configViewModel.capability) ?
                                <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [DEPART_STATUS.PARTIALLY_DEPARTED]
                                })}
                                stageStatus={{
                                    title: "depart.partiallyDeparted",
                                    message: "Partially departed",
                                    value: departMetrics.partialDepartedRoutes
                                }}/>: null
                            }
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [DEPART_STATUS.DEPARTED]
                                })}
                                stageStatus={{
                                    title: "cartContent.departed",
                                    message: "Departed",
                                    value: departMetrics.departedRoutes
                                }}/>
                        </Row>
                    </ScrollableElementWrapper>
                </Box>

            </Row>
        )

}

export default DepartOverallStatus


// WEBPACK FOOTER //
// ./src/components/depart/DepartOverallStatus.js